import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericAkitaHTTPService, HttpOptions } from '../../service/generic-akita-http.service';
import { SocialMediaSearch } from '../../model/social-media-search';
import { NetworkService } from '../../service/network.service';

@Injectable({
  providedIn: 'root'
})
export class AkitaSocialMediaSearchhHttpService extends GenericAkitaHTTPService<SocialMediaSearch> {
  constructor(http: HttpClient, networkService: NetworkService) {

    const options: HttpOptions = {
      params: {
        type: 'SocialMediaSearch',
        options: 'keyValues',
        limit: '100',
        orderBy: '!dateIssued'
      }
    };
    super(http, networkService, '/v2/entities/', 'socialmediasearch', options);
  }
}
